import { authService } from "@/services/authService";
import { useLocalStorage } from "@/components/pages/login/hooks/useLocalStorage";
import { useQueryClient } from "@tanstack/react-query";

export const useLogout = () => {
  const queryClient = useQueryClient();

  const { clearTokens } = useLocalStorage();

  const handleLogout = async () => {
    window.location.href = await authService.logout().finally(() => {
      clearTokens();
      queryClient.clear();
    });
  };
  return {
    handleLogout,
  };
};
